import { Component, EventEmitter, Input, OnInit, Output, Inject } from '@angular/core';
import {ICloseReturnType, PlaceholderChildComponent} from "@ispm/layout/classes/placeholder-child-component.abstract";
import {modalResponse} from "@ispm/layout/constants/modal-responses.enum";


@Component({
  selector: 'dynamic-required-fields.component',
  templateUrl: './dynamic-required-fields.component.html',
  styleUrls: ['./dynamic-required-fields.component.scss'],
})
export class DynamicRequiredFieldsComponent extends  PlaceholderChildComponent implements OnInit {

  public payload:{
    missingInformationBySampleType:null
  };



  beforeClose(_modalResponse: modalResponse | undefined): void | ICloseReturnType {
    return _modalResponse;
  }
  ngOnInit() {
    super.ngOnInit();
  }
}
